import '.ag{position:relative;}.ssr-plugin'
import '.a8{background-color:var(--palette-white);}.ssr-plugin'
import '.j1{border-radius:20px;}.ssr-plugin'
import '.a9{border:var(--border-subtle);}.ssr-plugin'
import '.c9{padding:1.5rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.j2{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.hp{width:2rem;}.ssr-plugin'
import '.bv{height:2rem;}.ssr-plugin'
import '.fo{border-radius:50%;}.ssr-plugin'
import '.j3{border:1px solid var(--palette-blue-800);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.z{justify-content:center;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.at{flex-shrink:0;}.ssr-plugin'
import '.j4{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="ag a8 j1 a9 c9 l j2"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--palette-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="hp bv fo j3 d z y at j4"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--palette-blue-800)',
                height: '1.25rem',
                width: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--palette-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
